import styled from "styled-components"
import React from "react"
import {useImageResource} from "hooks/queries/image-resource-query"

interface DeviceImageViewerProps {
    id: string,
    onClick: () => void
}
export const RemoteDeviceImageViewer = ({id, onClick}: DeviceImageViewerProps) => {
    const {data: imageResource} = useImageResource(id)
    if(!imageResource) return null
    const url = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_FILE_RESOURCE_URL}${imageResource.fileName}`
    console.log('url', url)
    return (
        <ImageBox >
            <img src={url} alt="장치 사진파일"
                 style={{height: 120, maxWidth: 120}}/>
            <div style={{position: "absolute", right: 3, top: 3}}>
                <div className="delete has-background-dark"
                     aria-label="close"
                     onClick={() => onClick()}/>
            </div>
        </ImageBox>
    )
}

interface LocalDeviceImageViewerProps {
    url: string
    onClick: () => void
}
export const LocalDeviceImageViewer = ({url, onClick}: LocalDeviceImageViewerProps) => {
    return (
        <ImageBox >
            <img src={url} alt="장치 사진파일"
                 style={{height: 120, maxWidth: 120}}/>
            <div style={{position: "absolute", right: 3, top: 3}}>
                <div className="delete has-background-dark"
                     aria-label="close"
                     onClick={() => onClick()}/>
            </div>
        </ImageBox>
    )
}

const ImageBox = styled.div`
  position: relative;
  display: inline-block;
  border: #ffffff solid 1px;
  margin-right: 10px;
  padding: 5px;

  &:hover {
    border: #00b89c solid 1px;
  }
`